import template from './BasicLayout.hbs';
import './BasicLayout.less';

import {Alias} from '../../../js/alias';
import {router} from '../../../js/router';
import {AppLoader} from '../AppLoader/AppLoader';
import {ModalRegion} from './ModalRegion/ModalRegion';
import {NotificationView} from '../NotificationView/NotificationView';
import {NotificationActionView} from '../NotificationActionView/NotificationActionView';
import {CookieUtils} from '../../utils/CookieUtils';
import {BaseView} from '../../../shared/view/BaseView';

/**
 * @class BasicLayout
 * @extends BaseView
 *
 * @property {ResourceLocator} model
 * @property {Mn.Region} contentLayout
 */
export class BasicLayout extends BaseView {

    get template () {

        return template;
    }

    get className () {

        return 'app-base-layout';
    }

    regions () {

        return {
            'navbar': '.header2',
            'content': '#app-cnt',
            'modal': {
                regionClass: ModalRegion,
                el: '#modal-cnt'
            },
            'modal2': '#modal2-cnt',
            'notification': {
                regionClass: ModalRegion,
                el: '#notification-cnt'
            },
            'cookieBanner': {
                el: '#cookie-banner'
            },
            'staging': '#staging-cnt'
        };
    }

    ui () {
        return {
            'rotationCnt' : '#rotation-cnt'
        };
    }

    initialize () {

        let notificationChannel = Radio.channel('NOTIFICATION');

        notificationChannel.on('MODAL', this.onModal, this);
        notificationChannel.on('MODAL2', this.onModal2, this);
        notificationChannel.on('NOTIFY', this.onNotify, this);
        notificationChannel.on('NOTIFY_ACTION', this.onNotifyAction, this);
        notificationChannel.on('NOTIFY:CLEAR', this.onNotifyClear, this);

        Radio.channel('ROUTER').on('ROUTE:START', this.toggleLoader, this);
        Radio.channel('NOTIFICATION').on('LS_MESSAGE:RECEIVED', this.onLsMessageReceived, this);
        Radio.channel('COOKIE_BANNER').on('CLOSE:COOKIE_BANNER', this.closeCookieBanner, this);
        Radio.channel('LAYOUT').on('NAVIGATIONBAR', this.onChildviewToggleNavigationbar, this);

        this.setOptCookieTracking();
        this.updateRotationContent();
    }

    onRender() {

        if (!navigator.cookieEnabled) {

            Radio.channel('NOTIFICATION').trigger('NOTIFY', {
                content: __('NO_COOKIE_NO_FUN'),
                autoClose: false
            });
        }
    }

    /**
     * Replaces content layout inside the basic
     * @param {ContentLayout} content
     */
    updateContent (content) {

        this.showChildView('content', content);
    }

    serializeData () {

        return {
            model: this.model,
            showCookieBanner: this.showCookieBanner(),
            isDemoModeOff: (ENV !== 'demo')
        };
    }

    showCookieBanner () {

        // don't show on local development
        if (ENV === 'local') {
            return;
        }

        // Do not show on mobile web view
        const isMobileRegistration = window.location.search.includes('mobileRegistration');

        if (isMobileRegistration) {
            return;
        }

        let cookieConfigs = CookieUtils.COOKIE_CONFIGS.cookieBannerConfigs;

        return !(CookieUtils.isCookieSet(cookieConfigs.cookieName, cookieConfigs.valueToStoreAndCheck));
    }

    toggleLoader (routeEvent, loadLayout) {

        if (loadLayout) {
            this.showChildView('content', new AppLoader());
        }
    }

    onNotify (options = null) {

        let notification = new NotificationView(_.extend({
            model: new Backbone.Model(),
            content: 'Something went wrong. Try to reload the page.'
        }, options));

        if(options !== null ) {

            if(options.responseCode !== 401) {

                this.showChildView('notification', notification);
            }
        }
        else {

            this.showChildView('notification', notification);
        }
    }

    onNotifyAction (options = null) {
        let notification = new NotificationActionView(_.extend({
            model: new Backbone.Model(),
            content: 'Something went wrong. Try to reload the page.'
        }, options));

        this.showChildView('notification', notification);
    }

    onNotifyClear () {

        this.getRegion('notification').empty();
    }

    closeCookieBanner () {

        this.getRegion('cookieBanner').empty();
    }

    /**
     * show the view in modal a window
     * @param {View} modal
     * @param {Boolean} isFocusEnabledOnInput
     */
    onModal (modal) {

        try {

            this.showChildView('modal', modal);
        } catch (e) {

            console.warn('You tried to show nulled modal.', e);
        }
    }

    /**
     * Show modal
     * @param {View} modal
     */
    onModal2 (modal) {
        try {
            this.showChildView('modal2', modal);
        } catch (err) {
            console.warn('Can\'t show modal', {modal, err});
        }
    }

    onLsMessageReceived (msg) {

        switch (msg) {

            case 'USER:LOGGEDIN' : {

                let routeEvent = router.getLastEvent();

                if (
                    routeEvent &&
                    (routeEvent.routeName !== Alias.PAGE_NOT_FOUND && routeEvent.routeName !== Alias.NOT_AUTHORIZED)
                ) {
                    //expire();
                    //router.navigateRelativelyToLocaleCode('/error-403');
                }

                break;
            }

            case 'OPT_COOKIE:TOGGLE' : {

                this.setOptCookieTracking();
                break;
            }
        }
    }

    setOptCookieTracking () {

        window[`ga-disable-${ window.GATrackingID }`] = CookieUtils.isCookieSet('TRACKING_DISABLED', true);
    }

    onChildviewToggleNavigationbar (isShown) {

        let navbar = this.getRegion('navbar');
        let content = this.getRegion('content');

        if(isShown){
            $(navbar.el).removeClass('hidden');
            $(content.el).addClass('show-nav-bar');
        } else {
            $(navbar.el).addClass('hidden');
            $(content.el).removeClass('show-nav-bar');
        }
    }

    updateRotationContent () {
        // show rotation content only for tablets
        if(ENV === 'demo') {
            require.ensure(['../../../js/resources/DemoData'], (require) => {

                let demoData = require('../../../js/resources/DemoData').DemoData;
                let clientInfoData = demoData.getClientInfoData();

                if(clientInfoData && (clientInfoData.isTablet === 'false') && this.ui.rotationCnt){
                    this.ui.rotationCnt.hide();
                }
            });
        } else {
            $.get({
                url: CLIENT_INFO_URL,
                ignoreSecurityOptions: true
            }).done((resp) => {
                if(resp && (resp.isTablet === 'false')){
                    this.ui.rotationCnt.hide();
                }
            }).fail(() => {
                console.warn('Client detection failed');
            });
        }
    }
}



// WEBPACK FOOTER //
// ./shared/view/BasicLayout/BasicLayout.js